import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';

export type ProLightCircleQuestionProps = IconComponentProps;

export const ProLightCircleQuestion = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCircleQuestionProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCircleQuestion}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCircleQuestion}
    />
  );
};

ProLightCircleQuestion.displayName = 'ProLightCircleQuestion';
